import axios from "axios";
import { useEffect, useState } from "react";
import apiCall from "../../components/Api/index";
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import CommonFIlterModal from "../../components/Common/CommonFilterModal";
import FilterOptions from "../../components/Common/CommonFilterOptions";
import Pagination from "../../components/Common/CommonPagination";
import NavBarTitles from "../../components/Common/TabBar";
import {
  experience,
  gender,
  language,
  service,
} from "../../components/Constants/index";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import LeadStatus from "../../components/Modal/LeadStatus";
import LeadStatusConfirm from "../../components/Modal/LeadStatusConfirm";
import SucessModal from "../../components/Modal/SucessModal";
import ExcelDownload from "../../components/Utils/excelDownload";
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";
import ExcelDownloadModal from "../../Pages/Masters/Common/excelDownloadAccess";
import {
  HealthcareRegistrationTable,
  HealthSynergynavBarData,
  HomeHealthcareServiceProvider,
} from "./HealthSynergyConst";

const DoctorRegistration = () => {
  const [filtered_records, setFilteredRecords] = useState([]);

  const skip = 0;
  const limit = 10;
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");

  const expdata = useState([]);
  const genderdata = useState([]);
  const languagedata = [];
  const servicedata = [];
  const location = "";

  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);
  const [leadStatusConfirmModal, setLeadStatusConfirmModal] = useState({
    leadType: "",
    status: false,
    id: "",
  });
  const [leadStatus, setLeadStatus] = useState([]);
  const filterLeadStatus = [];
  const [bdModal, setBdModal] = useState([]);
  const filterBdModal = [];
  const [search, setSearch] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [loader, setLoader] = useState(true);

  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Gender");
  const [selectedValues, setSelectedValues] = useState({
    Gender: [],
    Experience: [],
    "City / Town": [],
    Language: [],
    "Service Category": [],
    "Lead Status": [],
    BD: [],
  });

  const Filters = {
    Gender: gender,
    Experience: experience,
    "City / Town": [],
    Language: language,
    "Service Category": service,
    "Lead Status": leadStatus,
    BD: bdModal,
  };

  const filterRecordsFromSelected = () => {
    let filtered = [...records];

    const genderFilters = selectedValues["Gender"];
    const experienceFilters = selectedValues["Experience"];
    const cityTownFilters = selectedValues["City / Town"];
    const languageFilters = selectedValues["Language"];
    const serviceFilters = selectedValues["Service Category"];
    const leadStatusFilters = selectedValues["Lead Status"];
    const bdFilters = selectedValues["BD"];

    // Gender filter
    if (genderFilters?.length > 0) {
      filtered = filtered.filter((item) => genderFilters.includes(item.gender));
    }

    // Experience filter (calculated from registered_year)
    if (experienceFilters?.length > 0) {
      const currentYear = new Date().getFullYear();
      filtered = filtered.filter((item) => {
        const yearsOfExperience = currentYear - item.registered_year;
        return experienceFilters.some((range) => {
          if (range.includes("-")) {
            const [min, max] = range.split("-").map(Number);
            return yearsOfExperience >= min && yearsOfExperience <= max;
          }
          if (range.includes("+")) {
            const min = parseInt(range);
            return yearsOfExperience >= min;
          }
          return false;
        });
      });
    }

    // City / Town filter (case-insensitive partial match)
    if (cityTownFilters?.length > 0) {
      filtered = filtered.filter((item) =>
        cityTownFilters.some((loc) =>
          item.pharmacy_town?.toLowerCase().includes(loc.toLowerCase()),
        ),
      );
    }

    // Language filter
    if (languageFilters?.length > 0) {
      filtered = filtered.filter((item) =>
        item.languages_known?.some((lang) => languageFilters.includes(lang)),
      );
    }

    // Service Category (type) filter
    if (serviceFilters?.length > 0) {
      filtered = filtered.filter((item) => serviceFilters.includes(item.type));
    }

    // Lead Status filter
    if (leadStatusFilters?.length > 0) {
      filtered = filtered.filter((item) =>
        leadStatusFilters.includes(item.lead_status),
      );
    }

    // BD (Assigned To) filter
    if (bdFilters?.length > 0) {
      filtered = filtered.filter((item) =>
        bdFilters.includes(item.assigned_to),
      );
    }

    setFilteredRecords(filtered);
  };

  const handleSortClick = (selectedSort) => {
    setSort(selectedSort);
    setSortName(
      {
        newest: "Newest First",
        oldest: "Oldest First",
        ascending: "Alphabetic A-Z",
        descending: "Alphabetic Z-A",
      }[selectedSort] || "Sort by",
    );
  };
  useEffect(() => {
    getLeadStatus();
    getBdModal();
  }, []);

  const getLeadStatus = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}lead-status/list`, {
        noLimit: true,
      })
      .then((res) => {
        setLeadStatus(res.data.rows.map((lead) => lead?.type));
      });
  };

  const getBdModal = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}bd/list`, { noLimit: true })
      .then((res) => {
        setBdModal(res.data.rows.map((data) => data?.bd_name));
      });
  };

  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}healthcare-registration/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  useEffect(() => {
    !assignModal.status && !leadStatusModal.status && setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination.skip,
    pagination.limit,
    sort,
    search,
    success,
    leadStatussuccess,
    selectedValues,
  ]);

  const list_api_call = async (clearFilter = false) => {
    await apiCall(`healthcare-registration/list`, "POST", {
      // ...filter,
      skip: skip,
      limit: limit,
      // key: "healthcare_service",
      sort: sort,
      searchText: search,
      values: clearFilter
        ? {}
        : {
            service_category: servicedata,
            experience: expdata,
            gender: genderdata,
            languages_known: languagedata,
            location: location,
            lead_status: filterLeadStatus,
            assigned_to: filterBdModal,
          },
    });
    setFilteredRecords([]);
  };

  const onClickDownload = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}healthcare-registration/list`,
        {
          skip: 0,
          limit: 3000,
          searchText: search,
          values: {
            service_category: servicedata,
            experience: expdata,
            gender: genderdata,
            languages_known: languagedata,
            location: location,
            lead_status: filterLeadStatus,
            assigned_to: filterBdModal,
          },
          sort: sort,
        },
      );
      if (!response?.data?.rows?.length) {
        throw new Error("No records available to download.");
      }
      const records = response.data.rows;
      const formattedRecords = records.map((record, index) => ({
        "S.No": index + 1,
        "Time of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleTimeString()
          : "",
        "Date of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleDateString()
          : "",
        "Name of the HHSP": record.name || "",
        "Mobile Number": record.mobile || "",
        "Email ID": record.email || "",
        Degree: record.degree || "",
        "Other Certified Courses": record.other_certified_courses || "",
        Age: record.age || "",
        Gender: record.gender || "",
        "Service Category": record.service_category || "",
        "Experience (Year of Start)": record.experience || "",
        "License Number / Council Number /  Registration Number":
          record.license_number || "",
        "Memberships / Associations Details":
          record.memberships_or_associations || "",
        "About Yourself": record.about || "",
        Fee: record.fee || "",
        "Are your currently available on other home healthcare platforms?":
          record.other_home_healthcare_platforms || "",
        "Your Current Organisation Name (Hospital / Clinic Name)":
          record.establishment || "",
        Language: record.languages_known[0] || "",
        State: record.state || "",
        City: record.city || "",
        "Location (City / Town)": record.location || "",
        Address: record.address || "",
        Pincode: record.pincode || "",
        "BD Name": "",
        "App Download Android Click": record.android_click || 0,
        "App Download iOS Click": record.ios_click || 0,
        "Brochure Icon Click Status (1.0)": record.brochure_click || 0,
        "Assigned To": record.assigned_to || "",
        "Lead Status": record.lead_status || "",
      }));

      ExcelDownload(formattedRecords, "", "healthcare-registration.xlsx");
    } catch (err) {
      console.error(
        "Error downloading the file while getting all Doctor registration records",
        err,
        "err.message",
        err?.message,
      );
      alert(err?.message || "An error occurred while downloading the file.");
    }
  };

  const [del, setDel] = useState(false);
  const [id, setId] = useState("");

  const handleDelete = useDeleteHandler(
    "healthcare-registration",
    fetchData,
    setDel,
  );

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
    list_api_call();
  };

  const handlePageChange = usePageChange(pagination, setPagination);

  const debouncedSearch = useDebouncedSearch(setSearch, () => {
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
  });

  useEffect(() => {
    if (
      selectedValues["Gender"]?.length > 0 ||
      selectedValues["Experience"]?.length > 0 ||
      selectedValues["City / Town"]?.length > 0 ||
      selectedValues["Language"]?.length > 0 ||
      selectedValues["BService Category"]?.length > 0 ||
      selectedValues["Lead Status"]?.length > 0 ||
      selectedValues["BD"]?.length > 0
    ) {
      filterRecordsFromSelected();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [records]);

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={HomeHealthcareServiceProvider}
            />
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              Total Home Healthcare Service : {totalCount}
            </div>
            {totalCount > pagination.limit && (
              <Pagination
                skip={pagination.skip}
                limit={pagination.limit}
                total={totalCount}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={HealthSynergynavBarData} />
          <FilterOptions
            limit={pagination.limit}
            sortName={sortName}
            search={search}
            setFilterShow={() => setIsFilterModalVisible(true)}
            // setSortShow={setSortShow}
            onChange={debouncedSearch}
            setLimit={(val) =>
              setPagination((prev) => ({
                ...prev,
                limit: val,
                skip: 0,
                currentPage: 1,
              }))
            }
            downloadExcel={true}
            onClickDownload={() => setIsModalOpen(true)}
            handleSortClick={handleSortClick}
          />
        </div>
        <HealthcareRegistrationTable
          filtered_records={filtered_records}
          records={records}
          skip={skip}
          setAssignModal={setAssignModal}
          setLeadStatusModal={setLeadStatusModal}
          setId={setId}
          setDel={setDel}
          fetchData={fetchData}
          loader={loader}
        />
      </MainconternLayout>

      {del === true && (
        <Deletepopup
          handleDelete={handleDelete}
          id={id}
          handleClose={() => setDel(false)}
        />
      )}

      {/*---------Filter Portion--------*/}
      <CommonFIlterModal
        visible={isFilterModalVisible}
        onClose={() => {
          setIsFilterModalVisible(false);
          setSelectedCategory(Object.keys(Filters)[0]);
          if (filtered_records.length > 0) {
            setFilteredRecords([]);
            list_api_call(true); // fetch all records again
          }
          // Reset to first category
        }}
        onApply={async () => {
          await setIsFilterModalVisible(false);
          await setSelectedCategory(Object.keys(Filters)[0]);
          await filterRecordsFromSelected();
          await setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          await fetchData();
        }}
        onReset={() => {
          setSelectedValues({
            Gender: [],
            Experience: [],
            "City / Town": [],
            Language: [],
            "Service Category": [],
            "Lead Status": [],
            BD: [],
          });
          setFilteredRecords([]);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          setSelectedCategory(Object.keys(Filters)[0]);
          list_api_call(true);
        }}
        filters={Filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
        searchOnlyCategories={["City / Town"]}
      />

      {assignModal.status === true && (
        <AssignedTo
          id={assignModal?.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
          pathName="healthcare-registration"
        />
      )}

      {success && (
        <SucessModal
          name="BD"
          post="Assigned"
          onClick={() => successModalClose()}
          page="/healthcare-registration"
        />
      )}

      {leadStatusModal.status === true && (
        <LeadStatus
          id={leadStatusModal?.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
        />
      )}
      {leadStatusConfirmModal.status === true && (
        <LeadStatusConfirm
          id={leadStatusConfirmModal?.leadType}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          leadStatusConfirmModal={leadStatusConfirmModal}
          formType="healthcare-registration"
        />
      )}
      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          post="Updated"
          onClick={() => successModalClose()}
          page="/healthcare-registration"
        />
      )}
      <ExcelDownloadModal
        onClickDownload={onClickDownload}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default DoctorRegistration;
